module.exports = __webpack_public_path__ + "img/login_bg02.a95ea76a.jpg";